<div class="PillarToc">
  <div class="row">
    <ng-container *ngIf="pillars.length === 1">
      <div class="col-md-12">
        <document-pillar-toc
          *ngFor="let pillar of pillars;"
          [pillar]="pillar"
          [hideTitle]=true
          [newIndicatorDays]="newIndicatorDays">
        </document-pillar-toc>
      </div>
    </ng-container>
    <ng-container *ngIf="pillars.length > 1">
      <div class="col-md-6">
        <document-pillar-toc
          *ngFor="let pillar of pillars | evenodd:'odd';"
          [pillar]="pillar"
          [newIndicatorDays]="newIndicatorDays">
        </document-pillar-toc>
      </div>
      <div class="col-md-6">
        <document-pillar-toc
          *ngFor="let pillar of pillars | evenodd:'even';"
          [pillar]="pillar"
          [newIndicatorDays]="newIndicatorDays">
        </document-pillar-toc>
      </div>
    </ng-container>
  </div>
</div>
